// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__dVyML","mainContent":"Layout_mainContent__Bq4qw"};